module.exports = new __parcel__URL__("placeholderChart.2e601cdf.png").toString();